"use strict";

module.exports = function (fn) {
  return function (data) {
    fn(data);
    return Promise.resolve(data);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/promise/resolveThrough.js
// module id = 2197
// module chunks = 37